export default class autoComplete {
  constructor(config) {
    const {
      maxResults = 10, data = [], selector = '.autocomplete-input', wrapper = '.autoComplete_wrapper', onSelection
    } = config;
    // Max rows of result 
    this.maxResults = maxResults;
    // Data list
    this.data = data;
    // User input selector
    this.selector = selector;
    // Input selector
    this.wrapper = wrapper;
    // Selection callback
    this.onSelectionCallback = onSelection;
    // Active element
    this.activeIdx = -1;
    // Result rows
    this.items = [];
    // Initialize component
    this.init();
  }

  init() {
    this.autoInput = document.querySelector(this.selector);
    if (!this.autoInput) return;
    this.autoInput.addEventListener('keyup', (ev) => this.delay(this.keyupEventHandler(ev), 200));
    this.autoInput.addEventListener('click', (e) => this.toggleHandler(e));
    document.addEventListener('click', (e) => this.clickHandler(e));
  }

  delay(fn, ms) {
    let timer = 0
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(fn.bind(this, ...args), ms || 0);
    }
  }

  clear() {
    this.autoInput.value = '';
    this.clearContainerList();
  }

  keyupEventHandler(ev) {
    var keyCode = ev.which || ev.keyCode || 0;
    if (keyCode === 38 || keyCode === 40 || keyCode === 27 || keyCode === 13) {
      // Esc
      if (keyCode === 27) {
        this.clear();
      } else if (keyCode === 38 || keyCode === 40) {
        if (this.containerIsDisplayed()){
          ev.stopPropagation();
          ev.preventDefault();
          // Up
          keyCode === 38 ? this.selectPrev() : this.selectNext();
        }
      } else {
        // Enter
        if (this.containerIsDisplayed() && this.activeIdx !== -1) {
          this.onSelection(this.items[this.activeIdx].dataset);
        }
      }
      return;
    }
    this.update();
  }

  selectPrev() {
    this.activeIdx = this.activeIdx - 1;
    if (this.activeIdx >= this.items.length) this.activeIdx = 0;
    if (this.activeIdx < 0) this.activeIdx = this.items.length - 1;
    this.removeActive(this.items);
    this.items[this.activeIdx].classList.add('autoComplete_selected');
  }

  selectNext() {
    this.activeIdx = this.activeIdx + 1;
    if (this.activeIdx >= this.items.length) this.activeIdx = 0;
    if (this.activeIdx < 0) this.activeIdx = 0;
    this.removeActive(this.items);
    this.items[this.activeIdx].classList.add('autoComplete_selected');
  }

  removeActive(list) {
    Array.prototype.forEach.call(list, (item)=> {
      item.classList.remove('autoComplete_selected');
    });
  }

  toggleHandler(e) {
    e.stopPropagation();
    const container = document.querySelector('.autoComplete_list.is-show');
    if (container) {
      if (!e.target.closest('.autoComplete_list.is-show')) this.toggleAutoCompleteList();
    } else {
      this.update();
    }
  }

  clickHandler(e) {
    const container = document.querySelector('.autoComplete_list.is-show');
    if (container ){
      if (!e.target.closest('.autoComplete_list.is-show')) {
        this.toggleAutoCompleteList();
      } else {
        // onSelection
        if (e.target) {
          this.onSelection(Object.assign({}, e.target.dataset));
        }
      }
    }
  }

  onSelection(dataset) {
    this.autoInput.value = dataset['name'] ? dataset['name'] : '';
    this.clearContainerList();
    this.onSelectionCallback(dataset);
  }

  containerIsDisplayed() {
    return !!document.querySelector('.autoComplete_list.is-show');
  }

  toggleAutoCompleteList(isShow) {
    const container = document.querySelector('.autoComplete_list');
    if (isShow) {
      container.classList.add('is-show');
    } else {
      container.classList.remove('is-show');
    }
  }

  update() {
    var inputValue = this.autoInput.value;
    const items = this.data.filter((record) => {
      const highlight = this.match(inputValue, record.name);
      if (record.name !== highlight) {
        record.html = highlight;
        return true;
      }
      return false;
    });
    this.generateList(items);
  }

  match(query, record) {
    var recordLowerCase = record.toLowerCase();
    if (query.length > 0 && recordLowerCase.indexOf(query.toLowerCase()) > -1) {
      var pattern = new RegExp("".concat(query), "i");
      query = pattern.exec(record);
      return record.replace(query, "<span class=\"autoComplete_highlighted\">".concat(query, "</span>"));
    }
    return record;
  }

  clearContainerList () {
    const container = document.querySelector('.autoComplete_list');
    if (container) {
      container.parentNode.removeChild(container);
      this.activeIdx = -1;
    }
  }

  generateList(items) {
    const wrapper = document.querySelector(this.wrapper);
    items = items.slice(0, this.maxResults);
    this.clearContainerList();
    
    // Create a ul element that will contain the results items
    const list = document.createElement('ul');
    list.setAttribute("class", "autoComplete_list is-show");

    items.forEach(record => {
      const item = document.createElement('li');
      item.setAttribute("class", "autoComplete_result");
      item.innerHTML = record.html;
      item.dataset['key'] = record.id;
      item.dataset['name'] = record.name;
      item.dataset['value'] = record.value;
      list.appendChild(item);
    });
    if (items.length === 0 && this.autoInput.value.length > 0) {
      const item = document.createElement('li');
      item.setAttribute("class", "autoComplete_no_result");
      item.innerHTML = `Found No Results for "${this.autoInput.value}"`;
      list.appendChild(item);
    }
    if (list.children.length > 0) wrapper.appendChild(list);
    this.items = document.querySelectorAll('.autoComplete_result');
  }
}